<script lang="ts">
	import ModalView from '$lib/components/Modal/ModalView.svelte';
	import { _ } from 'svelte-i18n';
	import { page } from '$app/stores';
	import type { Widget } from '$lib/api/rpc';

	export let selectWidget: (widget: Widget) => void;

	if (!$page.data.respWidgets) throw new Error('TextEditor Widget: Missing widgets');

	const widgets = $page.data.respWidgets.onlyWidgets;
	const activeWidgets = widgets.filter(
		(widget) => widget.enabled && widget.format !== 'quick-poll'
	);
</script>

<ModalView>
	<div class="container">
		<h2>{$_('composer.widget.modal.title')}</h2>
		{#each activeWidgets as widget}
			<button
				type="button"
				on:click={() => {
					selectWidget(widget);
				}}>{widget.name}</button>
		{/each}
	</div>
</ModalView>

<style>
	.container {
		min-inline-size: 400px;
	}

	h2 {
		color: rgb(76 83 93);
		font-size: var(--fontSizeLarge);
		text-align: center;
	}

	button {
		all: unset;
		display: block;
		inline-size: 100%;
		color: rgb(76 83 93);
		line-height: 45px;
		text-align: center;
		cursor: pointer;
		border-block-end: 1px solid rgb(238 238 238);
	}

	button:hover {
		background-color: rgb(238 238 238);
	}
</style>
